export const transformEventName = (eventName:string)=>{
    return `cluster${eventName.substring(2).toLowerCase()}`
}